import { http } from "./client";

export const fetchHomeDashboard = (payload) => http.post("Home/dashboard", payload);
